<template>
  <div class="cmp-sub-tab mb-4 mb-md-0">
    <div ref="mySubTab" class="cmp-sub-tab-wrap g-tab-box pt-md-12 pc">
      <div class="item g-pointer" :class="{'active': activeTab===item.val}" v-for="(item, index) in tabList" :key="index" @click="clickTab(item, index)">
        {{item.name}}
        <i class="icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      activeVal: {
        type: String,
        default: '1'
      }
    },
    watch: {
      tabs(newVal) {
        this.tabList = newVal
      },
      activeVal(newVal) {
        this.activeTab = newVal
      }
    },
    data() {
      return {
        activeTab: this.activeVal || '1',
        tabList: this.tabs,
        currentIndex: 0
        // tabList: [
        //   {
        //     name: '展厅实景',
        //     val: '1',
        //   },
        //   {
        //     name: '展品详情',
        //     val: '2'
        //   }
        // ],
      }
    },
    methods: {
      clickTab(item, index) {
        if(this.activeTab !== item.val) {
          this.currentIndex = index
          this.activeTab = item.val
          // this.$emit('eventTabClick', item.val, index)
          this.$emit('eventTabClick', item.val, item, index)
          // this.getTabItemWidth()
        }
      },
      // 获取左移动位置
      getTabItemWidth() {
        let arr = this.$refs.mySubTab.getElementsByClassName('item')
        let lineLeft = 0  // 前面的宽度总和
        let currentWidth = 0 // 当前元素宽度
        for (let i = 0; i < arr.length; i++) {
          if (i < this.currentIndex) {
            lineLeft += arr[i].clientWidth
          } else if (i == this.currentIndex) {
            currentWidth = arr[i].clientWidth
          } else {
            break
          }
        }

        lineLeft = lineLeft + currentWidth / 2
        let containerWidth = this.$refs.mySubTab.clientWidth
        let scrollLeft = lineLeft - containerWidth / 2
        // console.log(lineLeft)
        // console.log(containerWidth)
        // console.log(scrollLeft)
        this.$refs.mySubTab.scrollLeft = scrollLeft
      }
    }
  }
</script>

<style lang="scss" scoped>
.cmp-sub-tab-wrap.g-tab-box {
  margin-bottom: 50px;
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // border-bottom: solid 2px $primary;
  .item {
    flex: 1;
    position: relative;
    // margin-right: 40px;
    font-size: 38px;
    padding-bottom: 10px;
    // line-height: 45px;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-bottom: solid 8px transparent;
    // .icon {
    //   margin-right: 10px;
    //   width: 16px;
    //   height: 22px;
    //   background: url(~@images/g-title-icon-gray.svg) no-repeat center center;
    //   background-size: 100% 100%;
    // }
     &.active {
      // font-weight: bold;
      border-bottom: solid 8px $primary;
      .icon {
        width: 22px;
        height: 12px;
        position: absolute;
        bottom: -18px;
        left: 50%;
        transform: translateX(-50%);
        background: url(~@images/icon_instructions@2x.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  &::after {
    content: '';
    width: 100%;
    height: 2px;
    background: $primary;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>